var pug = require("!../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (data) {pug_html = pug_html + "\u003Cdiv class=\"itemTemplate-text\"\u003E\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = data.CompanyName) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
// iterate data.display
;(function(){
  var $$obj = data.display;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var address = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = address) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var address = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = address) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv\u003E" + (pug.escape(null == (pug_interp = data.PhoneNumber) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";}.call(this,"data" in locals_for_with?locals_for_with.data:typeof data!=="undefined"?data:undefined));;return pug_html;};
module.exports = template;